import React from "react";

export default function FormGetData(props) {
  return (
    <div className="bg-white py-8 px-6 shadow rounded-lg sm:px-10">
      <form
        className="flex flex-col mx-4 space-y-6"
        onSubmit={props.handleSubmit}
      >
        <label className="label-input">
          From date:
          <input
            className="input text-sm"
            type="date"
            placeholder="From date"
            onChange={props.handleChange}
            name="startDate"
            value={props.formData.startDate}
          />
        </label>
        <label className="label-input">
          To date:
          <input
            className="input"
            type="date"
            placeholder="To date"
            onChange={props.handleChange}
            name="endDate"
            value={props.formData.endDate}
          />
        </label>
        <label className="label-input">
          What:
          <input
            className="input"
            type="text"
            placeholder="Keyword contained in event"
            onChange={props.handleChange}
            name="contains"
            value={props.formData.contains}
          />
        </label>
        <label className="label-input">
          Select a calendar
          <select className="input mb-6" onChange={props.handleCalendarChange}>
            {props.calendarList.map((calendar) => (
              <option key={calendar.id} name="calendarId" value={calendar.id}>
                {calendar.label}
              </option>
            ))}
          </select>
        </label>
        <button
          onClick={props.handleSubmit}
          type="button"
          className=" bg-secondaryGreen text-white hover:border-primaryGreen font-semibold py-2 px-4 mx-24 border border-primaryGreen hover:border-transparent rounded text-sm disabled:opacity-50 hover:bg-primaryGreen"
          disabled={!props.isSubmitButtonEnabled}
        >
          NEXT
        </button>
      </form>
    </div>
  );
}
